import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import es from '../locales/es.json';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			es: { translation: es },
			en: { translation: en }
		},

		fallbackLng: 'es',
		debug: process.env.NODE_ENV === 'development',
		interpolation: {
			escapeValue: false // React already does escaping
		},
		detection: {
			order: ['localStorage', 'navigator'],
			caches: ['localStorage']
		}
	});

export default i18n;
